<template>
  <footer class="z-9999 bottom-0 bg-black fixed noselect">
    <div class="progress-bar w-100 absolute top-0 bg-black-40" @click="onProgressClick">
      <div id="current-progress" ref="currentProgress"
           class="current-progress absolute left-0 top-0 h-100 flex justify-end">
        <div class="progress-circle br-100 absolute">
          <span v-show="currentSeconds" class="f7 tr seconds dn absolute textColor">{{ currentSeconds | time }}</span>
          <span class="f7 tr seconds dn absolute textColor">{{ minimumTrackDuration }}</span>
        </div>
      </div>
    </div>

    <div v-on-click-outside="closePlaylist" class="flex items-center justify-between w-100 h-100 textColor">
      <player-controls @changeVolume="volumeHandler" @mute="muteHandler"></player-controls>
      <transition name="fade">
        <div v-show="isPlaylistOpen" class="playlist flex flex-column self-end overflow-y-scroll pr1 pl1 textColor">
          <draggable v-model="playlist" :options="options">
            <div class="bb b--black-05 pa1 nowrap textColor" v-for="(track, index) in playlist"
                 v-show="!track.isAd"
                 :key="index"
                 :class="{'track-playing' : track === currentTrack}">
              <div class="drag-icon dib v-mid ma0 pointer textColor">
                <font-awesome-icon icon="bars" size="lg"></font-awesome-icon>
              </div>
              <a @click="changeTrack(track); closePlaylist()" class="dib v-mid"
                 :class="{'pointer': track === currentTrack}">
                <track-info :inPlayer="true" :inPlayerPlaylist="true" :track="track"></track-info>
              </a>
            </div>
          </draggable>
        </div>
      </transition>
      <track-info v-if="isCurrentAudioTrackSet" :inPlayer="true" :track="currentTrack" class="h-100"></track-info>
      <div v-if="!currentTrack.isAd" class="w4 dn db-ns tr textColor">
        <clip-loader :loading="!currentSeconds" :color="color" :size="size" class="mh2"></clip-loader>
        <span v-show="currentSeconds" class="f7 ph2 textColor">
          {{ currentSeconds | time }} - {{ currentTrack.seconds | time }}
        </span>
      </div>
      <a class="mr3 pa2 pointer textColor" v-show="isCurrentAudioTrackSet" @click="playlistTrigger">
        <font-awesome-icon icon="indent" size="lg"/>
      </a>
    </div>
  </footer>

</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import Howler from 'howler/dist/howler.js'
  import TrackInfo from '@/components/tracks/TrackInfo'
  import PlayerControls from './PlayerControls'
  import consts from '@/consts'
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import {mapGetters, mapActions} from 'vuex'
  import draggable from 'vuedraggable'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'player',
    components: {
      FontAwesomeIcon,
      TrackInfo,
      draggable,
      PlayerControls,
      ClipLoader
    },
    mixins: [onClickOutside],
    data () {
      return {
        howler: null,
        isCurrentAudioTrackSet: false,
        isPlaylistOpen: false,
        currentProgress: 0,
        color: '#808080',
        size: '20px',
        mytimerCounter: undefined,
        lastReportedTrack: null,
        trackIdShared: null,
        minimumTrackDuration: 0
      }
    },
    created () {
      this.checkUserLogged().then(() => {
        if (this.isShareTrack) {
          this.trackIdShared = null
          localStorage.removeItem('shareTrackId')
          this.setIsShareTrack(false)
        }
      }).catch(() => {
        if (this.isShareTrack) {
          let trackId = localStorage.getItem('shareTrackId')
          this.trackIdShared = trackId
        }
      })

      this.getMinTrackDuration().then((res) => {
        this.minimumTrackDuration = this.minTrackDuration
      })

      this.getPromotion().then(() => {
        if (this.playlist.length === 0) {
          this.setPlaylist(this.promotion)
          this.playFirstTrack()
        }
      })
      if ('mediaSession' in navigator) {
        navigator.mediaSession.setActionHandler('play', this.play.bind(this))
        navigator.mediaSession.setActionHandler('pause', this.pause.bind(this))
        navigator.mediaSession.setActionHandler('previoustrack', this.next.bind(this))
        navigator.mediaSession.setActionHandler('nexttrack', this.previous.bind(this))
      }
    },
    mounted () {
      document.addEventListener('keydown', (event) => {
        var inputs = ['input', 'textarea']
        var activeElement = document.activeElement
        if (!(activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1)) {
          if (event.which === 32) {
            this.setPlaying(!this.isPlaying)
            event.preventDefault()
          }
        }
      })
      /*
      const el = this
      const evt = function (event) {
        if (!el.isPlaying) {
          el.setPlaying(!el.isPlaying)
        }
        document.removeEventListener('click', evt, false)
      }
      document.addEventListener('click', evt, false)
      */
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'setPlaylist',
        'playNext',
        'playPrevious',
        'changeTrack',
        'playFirstTrack',
        'changeTrack',
        'addAdsToCurrentPlaylist',
        'removeAdsFromCurrentPlaylist',
        'setIsShareTrack',
        'getMinTrackDuration'
      ]),
      ...mapActions('track', [
        'getPromotion',
        'storeReproduction'
      ]),
      ...mapActions('user', [
        'checkUserLogged'
      ]),
      // Plays the received track
      playTrack (track) {
        if (this.howler) {
          this.howler.unload()
        }
        this.timerCounter()
        const el = this
        const vol = this.howler ? this.howler.volume() : 1
        if (!/\/uploads\/tracks\//.test(track.file)) {
          track.file = '/uploads/tracks/' + track.file
        }
        this.howler = new Howler.Howl({
          src: [consts.MEDIA_BASE_URL + track.file],
          html5: true,
          autoplay: true,
          volume: vol,
          onplayerror: function () {
            el.setPlaying(false)
          },
          onend: () => {
            this.lastReportedTrack = undefined
            if (this.currentTrack.isAd && this.isPlayingPrevious) {
              this.changeplayPrevious()
            } else {
              this.changeplayNext()
            }
          },
          onpause: () => {
            this.stoptimerCounter()
          },
          onplay: () => {
            this.timerCounter()
          }
        })
        /* para tener en cuenta cuando sea ncesario mostrar el progress de la carga
        const handleLoad = () => {
          const node = audio._sounds[0]._node;
          // const node:HTMLAudioElement = (audio as any)._sounds[0]._node; // For Typescript
          node.addEventListener('progress', () => {
            const duration = audio.duration();

            // https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/buffering_seeking_time_ranges#Creating_our_own_Buffering_Feedback
            if (duration > 0) {
              for (let i = 0; i < node.buffered.length; i++) {
                if (node.buffered.start(node.buffered.length - 1 - i) < node.currentTime) {
                  const bufferProgress = (node.buffered.end(node.buffered.length - 1 - i) / duration) * 100;
                  // do what you will with it. I.E - store.set({ bufferProgress });
                  break;
                }
              }
            }
          }
        };
        audio.on('load', handleLoad); */

        this.updateNotificationBar(track)
        this.isCurrentAudioTrackSet = true
        this.$_setProgress()
        clearInterval(this._currentInterval)
        this._currentInterval = setInterval(() => {
          this.$_setProgress(this.howler.seek() * 100 / this.howler.duration())
        }, 250)
      },

      $_setProgress (index = 0) {
        this.currentProgress = index
        this.$refs.currentProgress.style.width = `${index}%`
      },

      playlistTrigger () {
        this.isPlaylistOpen = !this.isPlaylistOpen
      },

      closePlaylist () {
        this.isPlaylistOpen = false
      },

      updateNotificationBar (track) {
        if (!/\/uploads\/tracks\//.test(track.picture)) {
          track.picture = '/uploads/tracks/' + track.picture
        }
        if (track.picture === '/uploads/tracks/undefined') {
          track.picture = '/static/assets/track4.jpg'
        }
        if ('mediaSession' in navigator) {
          // eslint-disable-next-line
          navigator.mediaSession.metadata = new MediaMetadata({
            title: track.title,
            artist: track.name,
            artwork: [
              {src: consts.MEDIA_BASE_URL + track.picture, type: 'image/jpeg'}
            ]
          })
        }
      },

      onProgressClick (event) {
        let playerWidth = this.$el.offsetWidth
        let totalSeconds = this.howler.duration()
        let clickPosition = event.clientX

        if (!this.currentTrack.isAd && this.howler.state('loaded')) {
          this.howler.seek(totalSeconds / playerWidth * clickPosition)
          this.$_setProgress(clickPosition * 100 / playerWidth)
        }
      },

      volumeHandler (volume) {
        if (this.howler) {
          this.howler.volume(volume)
        }
      },

      muteHandler (value) {
        if (this.howler) {
          this.howler.mute(value)
        }
      },
      timerCounter () {
        this.stoptimerCounter() // just in case there's any chance of calling timerCounter() twice in a row...
        this.setPlaying(true)
        var reproductionTimer = 0
        if (this.lastReportedTrack !== this.currentTrack && this.currentTrack.seconds > this.minimumTrackDuration) {
          var markedTrack = this.currentTrack.seconds * Math.random()
          this.mytimerCounter = setInterval(() => {
            if (!this.currentTrack.isAd) {
              if (reproductionTimer > markedTrack) {
                this.storeReproduction(this.currentTrack)
                this.lastReportedTrack = this.currentTrack
                clearInterval(this.mytimerCounter)
              } else {
                reproductionTimer++
              }
            }
          }, 1000)
        }
      },
      stoptimerCounter () {
        this.setPlaying(false)
        clearInterval(this.mytimerCounter) // will be a harmless no-op if mytimerCounter is false
        this.mytimerCounter = undefined // not strictly necessary, but just to be tidy
      },
      changeplayPrevious () {
        this.timerCounter()
        this.playPrevious()
      },
      changeplayNext () {
        this.timerCounter()
        this.playNext()
      }
    },
    computed: {
      ...mapGetters('player', [
        'isPlaying',
        'currentTrack',
        'canPrevious',
        'canNext',
        'playlist',
        'currentIndex',
        'isPlayingPrevious',
        'isShareTrack',
        'minTrackDuration'
      ]),
      ...mapGetters('track', [
        'promotion',
        'ads'
      ]),
      ...mapGetters('user', [
        'isSubscribed'
      ]),
      currentSeconds: function () {
        return Math.floor(this.currentProgress * this.currentTrack.seconds / 100)
      },
      playlist: {
        get () {
          return this.$store.state.player.playlist
        },
        set (value) {
          this.$store.commit('player/setPlaylist', value)
        }
      },
      options () {
        return {
          handle: '.drag-icon',
          disabled: !this.isSubscribed
        }
      }
    },
    watch: {
      currentTrack (newCurrentTrack) {
        if (this.trackIdShared !== null && this.trackIdShared !== newCurrentTrack.id) {
          this.setPlaying(false)
          this.$modal.show('login-unauthorized-user')
        } else {
          this.playTrack(newCurrentTrack)
        }
      },
      isPlaying (newValue) {
        if (this.howler) {
          if (newValue) {
            this.howler.play()
          } else {
            this.howler.pause()
          }
        }
      },
      isSubscribed () {
        if (this.isSubscribed) {
          this.removeAdsFromCurrentPlaylist()
        } else {
          this.addAdsToCurrentPlaylist()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  footer {
    width: 100% !important;
    height: $footer-height;
    padding-top: 5px;
  }

  .playlist {
    max-height: 300px;
    position: fixed;
    bottom: 50px;
    right: 0;
    background-color: $secondary-color;
    max-width: 400px;
  }

  .track-playing {
    background-color: lightgray;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .progress-bar {
    height: 5px;
    padding-top: 5px;
    
    &:hover {
      cursor: pointer;
    }
  }

  .progress-circle {
    width: 11px;
    height: 11px;
    top: -3px;
    right: -6px;
    background-color: $accent-color;
  }

  .seconds {
    top: -15px;
  }

  .progress-circle:hover .seconds {
    display: block;
  }

  .current-progress {
    width: 0;
    -webkit-transition: width 0.1s linear;
    -moz-transition: width 0.1s linear;
    -o-transition: width 0.1s linear;
    transition: width 0.1s linear;
    background-color: $accent-color !important;
  }

  @media screen and (max-width: 479px) {
    .playlist {
      width: 100%;
      max-width: 100%
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/player/Player.vue